import coinIcon from '../assets/coin-stack.svg';
import { PRODUCT_TYPE } from '../config/api';

const COIN_PRICE_TO_ICON = {
  399.99: 'assets/coin/coin12.webp',
  299.99: 'assets/coin/coin11.webp',
  199.99: 'assets/coin/coin10.webp',
  149.99: 'assets/coin/coin9.webp',
  99.99: 'assets/coin/coin8.webp',
  49.99: 'assets/coin/coin7.webp',
  19.99: 'assets/coin/coin6.webp',
  9.99: 'assets/coin/coin5.webp',
};

const GEM_PRICE_TO_ICON = {
  99.99: 'assets/gem/diamond_6.webp',
  49.99: 'assets/gem/diamond_5.webp',
  19.99: 'assets/gem/diamond_4.webp',
  9.99: 'assets/gem/diamond_3.webp',
};

const BASE_COIN_ICON = 'assets/coin/coin4.webp';
const BASE_GEM_ICON = 'assets/gem/diamond_2.webp';

const resolveMappedIcon = (iconMap, price, fallbackIcon) => {
  if (price in iconMap) {
    return iconMap[price];
  }

  const normalizedPrice = Number(price);
  if (!Number.isNaN(normalizedPrice) && normalizedPrice in iconMap) {
    return iconMap[normalizedPrice];
  }

  return fallbackIcon;
};

export const getProductIcon = (productType, price) => {
  if (productType === PRODUCT_TYPE.NEW_STORE_COIN) {
    return resolveMappedIcon(COIN_PRICE_TO_ICON, price, 'assets/coin/coin3.webp');
  }

  if (productType === PRODUCT_TYPE.BASE_COIN) {
    return BASE_COIN_ICON;
  }

  if (productType === PRODUCT_TYPE.NEW_STORE_GEM) {
    return resolveMappedIcon(GEM_PRICE_TO_ICON, price, 'assets/gem/diamond_3.webp');
  }

  if (productType === PRODUCT_TYPE.BASE_GEM) {
    return BASE_GEM_ICON;
  }

  if (productType === PRODUCT_TYPE.NEW_STORE_BOOST) {
    return coinIcon;
  }

  return coinIcon;
};

export const getProductTypeName = (productType) => {
  switch (productType) {
    case PRODUCT_TYPE.NEW_STORE_GEM:
    case PRODUCT_TYPE.BASE_GEM:
      return 'Gems';
    case PRODUCT_TYPE.NEW_STORE_BOOST:
      return 'Boost';
    case PRODUCT_TYPE.NEW_STORE_COIN:
    case PRODUCT_TYPE.BASE_COIN:
    default:
      return 'Coins';
  }
};
